import React, { useState } from 'react';
import {
    Box, Typography, Chip, Select, MenuItem, CircularProgress,
    Popover, FormControl, Button
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { updateSupport, createComment, reassignmentSupport } from '../../../../../services/supports/supports';
import { showAlert } from '../../../../../main_components/alerts/alert_response';
import UserAutocompleteInline, { type UserOption } from './userAutocompleteInline';
import EditIcon from '@mui/icons-material/Edit';

const statusColors: Record<string, { bg: string; color: string; label: string }> = {
    OPEN: { bg: '#E0E7FF', color: '#3730A3', label: 'ABIERTO' },
    REVIEW: { bg: '#FDE68A', color: '#92400E', label: 'EN REVISIÓN' },
    PROCESS: { bg: '#e8e4f2', color: '#1E40AF', label: 'EN PROCESO' },
    VALIDATION: { bg: '#FEF9C3', color: '#92400E', label: 'EN VALIDACIÓN' },
    CLOSE: { bg: '#E5E7EB', color: '#6B7280', label: 'FINALIZADO' },
};

const getCurrentTimestamp = (): string => {
    const now = new Date();
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
};

const TicketInfoPanel: React.FC<{
    tickets: any;
    currentStatus: string;
    setCurrentStatus: (status: string) => void;
    editingStatus: boolean;
    setEditingStatus: (editing: boolean) => void;
    statusUpdating: boolean;
    setStatusUpdating: (updating: boolean) => void;
    showReopenConfirm: boolean;
    setShowReopenConfirm: (show: boolean) => void;
    confirmReopenTicket: () => void;
    handleClick: (event: React.MouseEvent<HTMLElement>) => void;
    anchorEl: HTMLElement | null;
    handleClose: () => void;
    open: boolean;
    id: boolean | string;
    setResolving: (resolving: boolean) => void;
    onTicketUpdate?: (updatedTicket: any) => void;
    notificationSystemRef?: React.RefObject<any>;
    setComments: React.Dispatch<React.SetStateAction<any[]>>;

}> = ({
    tickets,
    currentStatus,
    setCurrentStatus,
    editingStatus,
    setEditingStatus,
    statusUpdating,
    setStatusUpdating,
    showReopenConfirm,
    setShowReopenConfirm,
    confirmReopenTicket,
    handleClick,
    anchorEl,
    handleClose,
    open,
    id,
    setResolving,
    onTicketUpdate,
    notificationSystemRef,
    setComments
}) => {


        const [editingUser, setEditingUser] = useState(false);
        const [newUser, setNewUser] = useState<UserOption | null>(null);
        const [userUpdating, setUserUpdating] = useState(false);
        const [assignedUser, setAssignedUser] = useState(tickets.user_name);
        const hasValidDomain = (email: string | null): boolean => {
            return email?.endsWith('@herramientasinformaticas.com') || false;
        };
        const email = sessionStorage.getItem("email_user_c");
        console.log(email)
        return (
            <Box>
                <Typography fontWeight={600} mb={2}>Información del Ticket</Typography>

                <Box
                    display="grid"
                    gridTemplateColumns="auto 1fr"
                    rowGap={1}
                    columnGap={1}
                    alignItems="center"
                    mb={2}
                >
                    <Typography variant="body2"><b>Estado:</b></Typography>

                    {statusUpdating ? (
                        <Chip
                            label="Actualizando..."
                            size="small"
                            icon={<CircularProgress size={14} color="inherit" />}
                            sx={{
                                bgcolor: '#DBEAFE',
                                color: '#1E40AF',
                                fontWeight: 'bold',
                                borderRadius: '16px',
                                px: 1.5,
                                fontSize: '13px',
                            }}
                        />
                    ) : editingStatus ? (
                        <FormControl size="small" sx={{ minWidth: 120 }}>
                            {/* Select original: NO se modifica tu lógica */}
                            <Select
                                value={currentStatus}
                                onChange={async (e) => {
                                    const newStatus = e.target.value;
                                    const previousStatus = currentStatus;
                                    setEditingStatus(false);
                                    const updatedTimestampComment = getCurrentTimestamp();

                                    const statusMessages: Record<string, string> = {
                                        PROCESS: `📌 El estado del ticket fue actualizado a "EN PROCESO" el día ${updatedTimestampComment}`,
                                        REVIEW: `El ticket fue puesto en revisión el día ${updatedTimestampComment} el equipo de soporte.`,
                                        CLOSE: `✅ El ticket fue cerrado el día ${updatedTimestampComment}`,
                                    };

                                    const baseComment = statusMessages[newStatus] || `📌 El estado del ticket fue actualizado a "${statusColors[newStatus]?.label || newStatus}" el día ${updatedTimestampComment}`;

                                    const commentData = {
                                        comment: baseComment,
                                        reply: null,
                                        edited: false,
                                        date: null as string | null,
                                        activate_alert: true,
                                        files: [],
                                        user_name: null as string | null,
                                        support_staff: null as boolean | null,
                                    };

                                    let finalCommentData = { ...commentData };
                                    let newComment: any = null;
                                    let createdCommentId: number | null = null;
                                    let createdDate = "";

                                    try {
                                        setStatusUpdating(true);
                                        const updatedTimestamp = getCurrentTimestamp();

                                        // await updateSupport(tickets.ticket, { status: newStatus });

                                        if (newStatus === "CLOSE") {
                                            await updateSupport(tickets.ticket, {
                                                status: newStatus,
                                                user_rate: 5,
                                                user_rate_comment: "CERRADO POR SISTEMA",
                                            });
                                        } else {
                                            await updateSupport(tickets.ticket, { status: newStatus });
                                        }

                                        setCurrentStatus(newStatus);

                                        if (["PROCESS", "REVIEW"].includes(newStatus)) {
                                            const response = await createComment(tickets.ticket, commentData);

                                            createdCommentId = response?.data?.id_comment | 120;
                                            createdDate = response.data.item.date;

                                            finalCommentData = {
                                                ...commentData,
                                                date: createdDate,
                                                user_name: response.data.item.user_name,
                                                support_staff: true,
                                                files: [],
                                            };

                                            newComment = {
                                                ...finalCommentData,
                                                id_comment: createdCommentId,
                                                responses: [],
                                            };

                                            setComments((prevComments) => [...prevComments, newComment]);
                                        }

                                        if (typeof onTicketUpdate === "function") {
                                            onTicketUpdate({
                                                ...tickets,
                                                status: newStatus,
                                                last_update: updatedTimestamp,
                                            });
                                        }

                                        showAlert({
                                            msj: "Estado actualizado correctamente.",
                                            status: true,
                                            notificationSystemRef,
                                        });
                                    } catch (err: any) {
                                        setCurrentStatus(previousStatus);
                                        showAlert({
                                            msj:
                                                err?.response?.data?.errorMessage ||
                                                "Error al actualizar el estado.",
                                            status: false,
                                            notificationSystemRef,
                                        });
                                    } finally {
                                        setStatusUpdating(false);
                                    }
                                }}
                                onBlur={() => setEditingStatus(false)}
                                sx={{
                                    borderRadius: "16px",
                                    fontSize: "13px",
                                    fontWeight: 600,
                                    backgroundColor:
                                        statusColors[currentStatus]?.bg || "#E5E7EB",
                                    color: statusColors[currentStatus]?.color || "#374151",
                                    paddingX: 1,
                                    "& .MuiSelect-select": {
                                        padding: "4px 10px",
                                    },
                                }}
                            >
                                {Object.entries(statusColors).map(([key, { label }]) => (
                                    <MenuItem key={key} value={key}>
                                        {label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    ) : (
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            width="100%"
                            sx={{
                                bgcolor: statusColors[currentStatus]?.bg || '#E5E7EB',
                                color: statusColors[currentStatus]?.color || '#374151',
                                borderRadius: '16px',
                                px: 1,
                                fontWeight: 'bold',
                                fontSize: '13px',
                            }}

                        >
                            {statusColors[currentStatus]?.label || currentStatus}
                            {hasValidDomain(email) && (<EditIcon
                                fontSize="small"
                                sx={{ cursor: 'pointer' }}
                                onClick={() => setEditingStatus(true)}
                            />
                            )}
                        </Box>

                    )}


                    {currentStatus === "CLOSE" && (
                        <>
                            <Typography variant="body2"><b>Reabrir:</b></Typography>
                            {!showReopenConfirm ? (
                                <Button size="small" onClick={() => setShowReopenConfirm(true)}>Reabrir ticket</Button>
                            ) : (
                                <Box display="flex" gap={1}>
                                    <Button onClick={confirmReopenTicket}>Sí</Button>
                                    <Button onClick={() => setShowReopenConfirm(false)}>No</Button>
                                </Box>
                            )}
                        </>
                    )}

                    <Typography variant="body2"><b>Prioridad:</b></Typography>


                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        width="100%"
                        sx={{
                            bgcolor: '#e2e2e2',
                            color: '#B91C1C',
                            borderRadius: '16px',
                            px: 1,
                            fontWeight: 'bold',
                            fontSize: '13px',
                        }}

                    >
                        {tickets?.severity?.toUpperCase() || 'No definida'}
                    </Box>

                    <Typography variant="body2"><b>Categoría:</b></Typography>
                    <Typography variant="body2">{tickets?.module || '—'}</Typography>
                    <Typography variant="body2"><b>Módulo:</b></Typography>
                    <Typography variant="body2">{tickets?.submodule || '—'}</Typography>
                    <Typography variant="body2"><b>Creado:</b></Typography>
                    <Typography variant="body2">{new Date(tickets.date).toLocaleDateString()}</Typography>
                    <Typography variant="body2"><b>Actualizado:</b></Typography>
                    <Typography variant="body2">
                        {tickets.last_update ? new Date(tickets.last_update).toLocaleDateString() : 'Sin fecha de actualización'}
                    </Typography>


                    {tickets?.recurrent_incidence && (
                        <>
                            <Typography variant="body2"><b>Cuando lo reportó:</b></Typography>
                            <Typography variant="body2">{tickets?.note_latest_report || '—'}</Typography>
                        </>
                    )}
                    <Typography variant="body2"><b>Creado por:</b></Typography>
                    <Box display="flex" alignItems="center" gap={1}>
                        {userUpdating ? (
                            <Chip
                                label="Actualizando..."
                                size="small"
                                icon={<CircularProgress size={14} color="inherit" />}
                                sx={{
                                    bgcolor: '#DBEAFE',
                                    color: '#1E40AF',
                                    fontWeight: 'bold',
                                    borderRadius: '16px',
                                    px: 1,
                                    fontSize: '13px',
                                }}
                            />
                        ) : (
                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                width="100%"
                                sx={{
                                    bgcolor: '#D1FAE5',
                                    color: '#065F46',
                                    borderRadius: '16px',
                                    px: 1,
                                    fontWeight: 'bold',
                                    fontSize: '13px',
                                }}
                            >
                                {assignedUser || '—'}
                                {hasValidDomain(email) && (
                                    <EditIcon
                                        fontSize="small"
                                        sx={{ cursor: 'pointer' }}
                                        onClick={() => setEditingUser(true)}
                                    />
                                )}
                            </Box>
                        )}
                    </Box>




                </Box>
                {editingUser && !userUpdating && (
                    <Box mb={2}>
                        <UserAutocompleteInline
                            value={null}
                            onChange={(val) => setNewUser(val)}
                            onBlur={() => { }}
                        />
                        {newUser && (
                            <Box mt={1} display="flex" gap={1} sx={{ width: '100%' }}>
                                <Button
                                    variant="contained"
                                    size="small"
                                    sx={{ width: '100%' }}
                                    onClick={async () => {
                                        setUserUpdating(true)
                                        let reassigned = false;
                                        const updatedTimestamp = getCurrentTimestamp();

                                        // 1️⃣ Intentar reasignar el ticket
                                        try {
                                            await reassignmentSupport(tickets.ticket, {
                                                user_name: newUser.fullusername,
                                                user_email: newUser.email
                                            });
                                            setAssignedUser(newUser.fullusername);
                                            reassigned = true;

                                        } catch (err) {
                                            showAlert({
                                                msj: '❌ Error al reasignar el ticket.',
                                                status: false,
                                                notificationSystemRef,
                                            });
                                            return;
                                        }

                                        // 2️⃣ Intentar crear el comentario solo si se reasignó correctamente
                                        try {
                                            const formattedDate = new Date().toLocaleString('es-MX', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                            });

                                            const commentData = {
                                                comment: `📩 Soporte HI reasignó este ticket a *${newUser.fullusername}* el día ${formattedDate}`,
                                                reply: null,
                                                edited: false,
                                                date: null,
                                                activate_alert: true,
                                                files: [],
                                                user_name: "SOPORTE",
                                                support_staff: true,
                                            };

                                            const commentRes = await createComment(tickets.ticket, commentData);

                                            const finalComment = {
                                                ...commentData,
                                                date: commentRes.data.item.date,
                                                user_name: commentRes.data.item.user_name,
                                                support_staff: commentRes.data.item.support_staff,
                                                id_comment: commentRes.data.id_comment,
                                                responses: [],
                                            };

                                            setComments(prev => [...prev, finalComment]);

                                            showAlert({
                                                msj: 'Ticket reasignado y comentario creado correctamente.',
                                                status: true,
                                                notificationSystemRef,
                                            });

                                            setEditingUser(false);
                                            setNewUser(null);

                                            if (typeof onTicketUpdate === "function") {
                                                onTicketUpdate({
                                                    ...tickets,
                                                    user_name: newUser.fullusername,
                                                    last_update: updatedTimestamp,
                                                });
                                            }
                                            setUserUpdating(false)



                                        } catch (err) {
                                            setUserUpdating(false)

                                            showAlert({
                                                msj: '⚠️ Ticket reasignado, pero falló al crear el comentario.',
                                                status: false,
                                                notificationSystemRef,
                                            });
                                        }
                                    }}

                                >
                                    Reasignar
                                </Button>
                                <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={() => {
                                        setEditingUser(false);
                                        setNewUser(null);
                                    }}
                                >
                                    Cancelar
                                </Button>
                            </Box>
                        )}
                    </Box>
                )}




                <Typography
                    mt={2}
                    sx={{ cursor: 'pointer', wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}
                    onClick={handleClick}
                    aria-describedby={"description-popover"}
                    title={tickets.description}
                >
                    <b>Descripción:</b> {tickets.description?.slice(0, 60) + (tickets.description?.length > 60 ? '...' : '')}
                </Typography>


                <Popover
                    id={"description-popover"}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    PaperProps={{ sx: { maxWidth: 400, p: 2 } }}
                >
                    <Typography><b>Descripción completa:</b> {tickets.description}</Typography>
                </Popover>

                <Box mt={3}>
                    <Button
                        fullWidth
                        startIcon={<CheckCircleOutlineIcon />}
                        variant="outlined"
                        sx={{
                            color: currentStatus === "CLOSE" ? '#22C55E' : '#7C3AED',
                            borderColor: currentStatus === "CLOSE" ? '#22C55E' : '#7C3AED'
                        }}
                        onClick={() => {
                            if (currentStatus !== "CLOSE") setResolving(true);
                        }}
                        disabled={currentStatus === "CLOSE"}
                    >
                        {currentStatus === "CLOSE" ? "FINALIZADO" : "MARCAR COMO RESUELTO"}
                    </Button>
                </Box>
            </Box>
        );
    };

export default TicketInfoPanel;
